import { BehaviorSubject, of } from 'rxjs';
import { distinctUntilChanged, finalize, map, startWith, switchMap, tap } from 'rxjs/operators';

export function buildWorkMonitor() {
    let workingCounter$ = new BehaviorSubject(0);
    let working$ = workingCounter$.pipe(
        map(counter => counter > 0),
        distinctUntilChanged(),
    );

    function changeWorkingCounter(delta) {
        workingCounter$.next(workingCounter$.value + delta);
    }

    function zone(zone) {
        return of(undefined).pipe(
            tap(() => changeWorkingCounter(1)),
            switchMap(() => zone),
            finalize(() => changeWorkingCounter(-1)),
        );
    }

    function showElements(selector) {
        return working$.pipe(
            startWith(false),
            tap(working => {
                let op = working ? DOMTokenList.prototype.remove : DOMTokenList.prototype.add;
                for (let el of document.querySelectorAll(selector)) {
                    op.call(el.classList, 'hidden');
                }
            }),
        );
    }

    function alertBeforeUnload() {
        return working$.pipe(
            source$ => {
                let registered = false;
                return source$.pipe(
                    tap(working => {
                        if (working) {
                            register();
                        } else {
                            unregister();
                        }
                    }),
                    finalize(() => unregister()),
                );

                function register() {
                    window.addEventListener('beforeunload', handler, false);
                }

                function unregister() {
                    window.removeEventListener('beforeunload', handler, false);
                }
            },
        );

        function handler(evt) {
            evt.preventDefault();
            evt.returnValue = '';
            return '';
        }
    }
    
    return {
        working$,
        zone,
        showElements,
        alertBeforeUnload,
    };
}
